export default __webpack_public_path__ + "media/zurb/img/curve-bg-d199ac46e37e36d92d1446b4c98e4342.svg";